<template>
  <footer>
    <div class="">
        
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComp',
  mounted(){

  }
}
</script>

<style scoped>

</style>
